<template>
    <div class="modal-blurred-profile" v-if="showModal">
        <div class="modal-blurred-profile-content">
            <div class="modal-blurred-profile-header">
                <span class="modal-blurred-profile-close" @click="closeModal">&times;</span>
            </div>
            <div class="modal-blurred-profile-body">

                <div class="modal-blurred-profile-body-header">
                    {{ translate.account.blurModal.header }}
                </div>
                <div class="modal-blurred-profile-body-header-benefits">
                    {{ translate.account.blurModal.benefitsHeader }}
                </div>
                <div class="modal-blurred-profile-body-benefits-list">
                    <span class="modal-blurred-profile-body-benefits-list-item">
                        {{ translate.account.blurModal.benefits1 }}
                    </span>
                    <span class="modal-blurred-profile-body-benefits-list-item">
                        {{ translate.account.blurModal.benefits2 }}
                    </span>
                    <span class="modal-blurred-profile-body-benefits-list-item">
                        {{ translate.account.blurModal.benefits3 }}
                    </span>
                    <span class="modal-blurred-profile-body-benefits-list-item">
                        {{ translate.account.blurModal.benefits4 }}
                    </span>
                    <span class="modal-blurred-profile-body-benefits-list-item">
                        {{ translate.account.blurModal.benefits5 }}
                    </span>
                </div>

                <div class="modal-blurred-button-register-wrapper mt-5">
                    <a :href="regionRelativeUrl('/users/registration/')" class="btn btn-secondary" @click.prevent="onRegistrationClick">
                        <span>{{ translate.account.blurModal.buttonRegister }}</span>
                        <icon-component :icon="fa_lock_open_alt()" width="1.25em"></icon-component>
                    </a>

                    <a :href="redirectProfilePathQuery(profileUser.profile_path)" class="btn btn-secondary ml-4"
                       @click.prevent="onLoginClick">
                        <span>{{ translate.account.blurModal.signIn }}</span>
                        <icon-component :icon="fa_lock_open_alt()" width="1.25em"></icon-component>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import requestQueryEnum from "../../core/constants/requestQueryEnum";
import {fa_lock_open_alt} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => {
    return {
        showModal: false,
        $: null,
        msDelayBeforeLocationChange: 500,
    }
}

function created() {
    if (typeof $ !== "undefined") {
        this.$ = $;
    }
}

function openModal() {
    if (typeof hasCookieConsentSet === "undefined") {
        return;
    }

    this.showModal = hasCookieConsentSet();

    if (this.showModal) {
        this.$(() => {
            if (this.$('body').length) {
                this.$('body').addClass('disable-scroll');
            }
        })

        this.captureTrackingEvent(null, 'profile', 'pay2display_modal', 'modal_popup', _.get(this, 'profileUser.id'));
    }
}

function closeModal() {
    this.captureTrackingEvent(null, 'profile', 'pay2display_modal', 'back_click', _.get(this, 'profileUser.id'));

    this.showModal = false;

    this.$(() => {
        if (this.$('body').length) {
            this.$('body').removeClass('disable-scroll');
        }
    })
}

function onRegistrationClick() {
    this.captureTrackingEvent(null, 'profile', 'pay2display_modal', 'registration_click', _.get(this, 'profileUser.id'));

    setTimeout(() => {
        if (typeof window !== "undefined") {
            window.location.href = this.regionRelativeUrl('/users/registration/');
        }
    }, this.msDelayBeforeLocationChange)
}

function onLoginClick() {
    const profileUser = _.get(this, 'profileUser', {})
    this.captureTrackingEvent(null, 'profile', 'pay2display_modal', 'login_click', profileUser.id);

    setTimeout(
        () => {
            if (typeof window !== "undefined") {
                window.location.href = this.regionRelativeUrl(this.redirectProfilePathQuery(profileUser.profile_path));
            }
        },
        this.msDelayBeforeLocationChange
    )
}

/**
 * @param {string} profilePath
 * @returns {string}
 */
function redirectProfilePathQuery(profilePath) {
    return `/users/login/?${requestQueryEnum.REDIRECT_PROFILE_PATH_QUERY}${profilePath}`
}

export default {
    components: {IconComponent},
    data,
    created,
    computed: {
        ...mapState(['translate']),
    },
    methods: {
        fa_lock_open_alt,
        onRegistrationClick,
        onLoginClick,
        redirectProfilePathQuery,
        openModal,
        closeModal,
    },
    mixins: [
        xtrackingMixin,
        regionsUrlMixin,
    ],
    props: ['profileUser'],
    beforeDestroy() {
        this.$(() => {
            if (this.$('body').length) {
                this.$('body').removeClass('disable-scroll');
            }
        })
    }
}
</script>
